import { triggerEvent } from "./helpers";
import Carousel from "./Carousel";

export default class FinnCarousel extends Carousel {
  addSlides(nodes) {
    const { mainContainer } = this.options;

    if (!nodes || nodes.length <= 0) return;

    const slidesNodes = nodes.reduce((acc, cur) => {
      const wrapperNode = document.createElement("div");
      wrapperNode.classList.add("main-tiles-unit-wrapper");
      const span = Math.min(parseInt(cur.dataset.span, 10) || 1, this.perPage);
      wrapperNode.style.width = `${(100 / this.perPage) * span}%`;
      wrapperNode.appendChild(cur);

      acc.appendChild(wrapperNode);
      this.slides = [...this.slides, wrapperNode];

      return acc;
    }, document.createDocumentFragment());

    this.tilesContainer.appendChild(slidesNodes);

    this.recomputeTotalPages();
    this.refreshSlider();
    this.initAutoRotate();

    triggerEvent(mainContainer, "add-slides.after.innocode-carousel");
  }

  refreshSlides() {
    const tilesNodes = this.tilesContainer.childNodes;
    for (let i = 0; i < tilesNodes.length; i += 1) {
      const wrapper = tilesNodes[i];
      const tileNode = wrapper.firstChild;
      const span = Math.min(parseInt(tileNode?.dataset?.span, 10) || 1, this.perPage);
      wrapper.style.width = `${(100 / this.perPage) * span}%`;
    }
  }
}
